import { render, staticRenderFns } from "./SendEmailModal.vue?vue&type=template&id=a4e7f986"
import script from "./SendEmailModal.vue?vue&type=script&lang=ts"
export * from "./SendEmailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports